module.exports = __webpack_public_path__ + "img/tmk.01029cac.jpg";